import React, { useState, useCallback } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import ClientDashboard from "./pages/ClientDashboard";
import AdminApp from "./AdminApp";

function getUserRole() {
  try {
    const token = localStorage.getItem("token");
    if (!token) return null;
    return JSON.parse(atob(token.split(".")[1])).role || null;
  } catch { return null; }
}

export default function App() {
  const [role, setRole] = useState(getUserRole);

  const handleLogin = useCallback(() => {
    setRole(getUserRole());
  }, []);

  const handleLogout = useCallback(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("bc_avatar");
    setRole(null);
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login onLogin={handleLogin} />} />
        <Route path="/client" element={
          role === "user" || role === "admin"
            ? <ClientDashboard onLogout={handleLogout} />
            : <Navigate to={`/login?from=${window.location.pathname.replace("/","")}`} replace />
        } />
        <Route path="/*" element={
          role === "admin"
            ? <AdminApp onLogout={handleLogout} />
            : role === "user"
            ? <Navigate to="/client" replace />
            : <Navigate to={`/login?from=${window.location.pathname.replace("/","")}`} replace />
        } />
      </Routes>
    </BrowserRouter>
  );
}// force 1786606248
